<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
localStorage.clear();
import CryptoJS from 'crypto-js';
export default {
    name: 'App',
    data(){
      return{
         toast:"",
      }
    },
    created(){
        this.toast = this.$createToast({
          time: 0,
          txt: '正在登陆中',
          mask: true
        })
        this.toast.show();
        var token = window.localStorage.getItem('access_token');
        if(token==null){
          localStorage.clear();//清空缓存数据
          this.init();
        }else{
          this.leaveMsg(token)
        }
    },
    methods:{
        init(){
          var code = this.getUrlParam('code')
          var local = window.location.href;
          // var APPID = 'wx108488299b9273db';
          var APPID = 'wxed58f85c60ee70cd'
           
          // // var code = getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
          // var local = 'http://wechat.dgybwj.kuaichuangkeji.com';
          // // var APPID = 'wxbaab381536b8c8c6';
          if (code == null || code === '') {
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect'
          } else {
            // console.log(code);
            this.getOpenId(code)
          }
            // this.$http.post(`${this.service}user/login`,{
            //     openid:'ohJmA4mMRUq-_l8Tzv_OLbuz5vFo'
            // }).then((data)=>{
            //     if(data.status == 1){
            //         console.log(data.access_token);
            //         this.$store.commit('setAccessToken',data.access_token);
            //         this.leaveMsg(data.access_token);
            //     }
            // })
        },
        getOpenId(code){
          // console.log(code,123)
          this.$http.post(`${this.service}user/login`,{
              code:code
          }).then((data)=>{
              if(data.status == 1){
                  console.log(data.access_token);
                  this.$store.commit('setAccessToken',data.access_token);
                  this.leaveMsg(data.access_token);
                  window.localStorage.setItem('access_token',data.access_token);
                  window.localStorage.setItem('avatar',data.avatar);
                  window.localStorage.setItem('nickname',data.nickname);
              }
          })
        },
        getUrlParam(name) {
          var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          var r = window.location.search.substr(1).match(reg);
          if (r != null) return unescape(r[2]); return null;
        },
        leaveMsg(access_token){
          this.$http.get(`${this.service}questionnaire/status?access-token=${access_token}`).then((data)=>{
            window.localStorage.setItem('sfzc',JSON.stringify(data));
            // console.log(data,'123')
              // this.$store.commit('setStatus',data);
              // wx.hideLoading();
              // this.toast.hide();
          });
          this.$http.get(`${this.service}questionnaire/config`).then((data)=>{
            window.localStorage.setItem('setStatus',JSON.stringify(data));

              // this.$store.commit('setStatus',data);
             // wx.hideLoading();
             this.toast.hide();
          })
          // this.wechat();
        }
    }
}
</script>

<style lang="less">
  #app{ width: 100%; height: 100%;}
</style>


// WEBPACK FOOTER //
// src/AppH5.vue